<template>
  <div id="carousel" class="carousel slide text-light" data-ride="carousel">
    <ol class="carousel-indicators">
      <li v-for="(slide, indicatorIndex) in sliderItems" data-target="#carousel" :data-slide-to="indicatorIndex" :class="{'active': indicatorIndex == activeSlideIndex}" :key="'indicator-'+indicatorIndex" @click="activeSlideIndex = indicatorIndex"></li>
    </ol>
    <div class="carousel-inner pt-2 pb-2">
      <div v-for="(slide, slideIndex) in sliderItems" :class="['carousel-item', slideIndex == activeSlideIndex ? 'active' : '']" :key="'slide-' + slideIndex">
        <div class="dflex">
          <div class="media">
            <div class="pr-5">
              <a :href="ctaButtonBaseLink + '/' + slide[ctaButtonLinkField]">
                <rounded-image :name="slide['name']" 
                               :image="slide['image']"
                               :height="120">
                </rounded-image>
              </a>
              <div>
                <a :href="ctaButtonBaseLink + '/' + slide[ctaButtonLinkField]" class="btn btn-sm btn-outline-light">
                {{ ctaButtonText }}&nbsp;<i class="fa fa-angle-right"></i>
                </a>
              </div>
            </div>
            <div class="media-body">
              <div class="slider-text">
                <h2>{{ slide[sliderHeaderField] }}</h2>
                <div v-html="slide[sliderMainTextField]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a class="carousel-control-prev" href="#carousel" role="button" data-slide="prev" @click.stop.prevent="previousSlide()">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    </a>
    <a class="carousel-control-next" href="#carousel" role="button" data-slide="next" @click.stop.prevent="nextSlide()">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
    </a>
  </div>
</template>

<script>
export default {
    props: {
        sliderItems: { type: Array, required: true },
        sliderHeaderField: { type: String, required: true },
        sliderMainTextField: { type: String, required: true },
        ctaButtonText: { type: String, required: true },
        ctaButtonBaseLink: { type: String, required: true },
        ctaButtonLinkField: { type: String, required: true }
    },

    data() {
        return {
            activeSlideIndex: 0,
            numberOfSlides: Object.keys(this.sliderItems).length,
        }
    },
    mounted() {
      this.sliderMainTextField = this.sliderMainTextField.substring(0, 100)

      $('.carousel').carousel({
        interval: false,
        wrap: false,
      });

      this.$root.$on('setSliderToSlideWithId', slideId => {
          this.activeSlideIndex = slideId;
      });
    },

    methods: {
      nextSlide() {
        if (this.activeSlideIndex < this.numberOfSlides - 1) {
          this.activeSlideIndex = this.activeSlideIndex + 1;
        }
      },

      previousSlide() {
        if (this.activeSlideIndex > 0) {
          this.activeSlideIndex = this.activeSlideIndex - 1;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
  #carousel {
    background-color: #4e725b;
    min-height: 300px;

    &::v-deep .slider-text {
      h2 {
        font-weight: normal;
        letter-spacing: 2px;
        font-size: 2rem;
      }
    }

    .media {
      padding: 3rem 6rem;

      @media (max-width: 768px) {
        padding: 1rem 2rem;
      }

      img {
        margin-top: 20px;
        max-width: 120px;
      }

      &::v-deep .slider-text {
        color: #fff !important;
        font-size: 1.4rem;
        height: 150px;
        line-height: 1.6rem;
        margin: 10px 0;

        a {
          color: white;
          text-decoration: underline;
        }
      }

      a.btn {
        margin-top: 10px;
        letter-spacing: 1px;
        border-color: #fff;
        color: #fff;
        text-transform: uppercase;
        font-size: 1rem;

        &:hover {
          color: white;
          background-color: darken($color: #4e725b, $amount: 30);
        }
      }
    }
    
    .carousel-indicators li {
      border-radius: 50%;
      height: 10px;
      width: 10px;
    }

    .carousel-control-prev, .carousel-control-next {
      width: 5%;

      &:hover {
        background: transparent;
      }
    }
  }
</style>